import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SecondFaModal } from './second-fa-modal/second-fa-modal';
import { ActivatedRoute } from '@angular/router';
import { FidoCredentialOutput, FidoTokenComponent } from './fido-token/fido-token.component';
import { SoftTokenOutput } from './soft-token/soft-token.component';
import { EnrollmentInputModel } from './models/enrollmentinput.model';
import { FidoInputModel } from './models/fidoinput.model';
import { SofttokenInputModel } from './models/softtokeninput.model';

@Component({
  standalone: false,
  selector: 'app-enrollment',
  templateUrl: './enrollment.component.html',
  styleUrls: ['./enrollment.component.scss']
})

export class EnrollmentComponent implements OnInit, OnDestroy {
  [key: string]: any;

@Input() options!: EnrollmentInputModel;

  @Output() savedEnrollment: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(FidoTokenComponent) fidoTokenComponent!: FidoTokenComponent;

  subscriptions: Subscription = new Subscription;

  fidoOptions!: FidoInputModel;
  softtokenOptions!: SofttokenInputModel;

  enrollmentFormPrimary!: FormGroup;
  enrollmentFormSecondary!: FormGroup;
  authMethodConfig!: AuthenticationMethodConfiguration;
  authTypeData: any;
  tokens = [];
  tokensBuffer = [];
  loading = false;
  bufferSize = 20;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  isEdit = false;
  authenticationMethod: typeof AuthenticationMethod = AuthenticationMethod;
  allowUserCodeLength: number = 0;
  disableSecondFactor: boolean = true;
  buttonDisabled = true;
  authTypeName: string = AuthenticationMethod.Password;
  authTypeName2FA: string = AuthenticationMethod.PassCode;
  defaultAuthType = '';
  defaultAuthType2FA = '';
  pushEnabled: boolean = true;
  genericSoftToken: boolean = false;
  pushEnforced: boolean = false;
  pushAllowed: boolean = true;
  softTokenType: string = 'securenvoy';
  authUserType: string = "";
  loginUsername = '';
  isForLoggedInUser = false;
  secondAuthenticationMethod!: string[];
  allowSecondFactor = true;
  secondFactorEnforce = true;
  isSmsEnable = true;
  isEmailEnable = true;
  showStaticCode = false;
  showSerialNumber = false;
  authenticationTypeModel: UserAuthenticationTypeList = {
    UserAuthenticationTypeModelList: [
      {
        authenticationTypeId: 0,
        authenticationTypeName: AuthenticationMethod.Password,
        userName: '',
        organizationMnemonic: '',
        sequence: 1,
        jsonData: null,
        isActive: true,
        isDefault: true,
        userCheckEnrollCodeModel: null,
        revertAtTime: null,
      },
      {
        authenticationTypeId: 0,
        authenticationTypeName: '',
        userName: '',
        organizationMnemonic: '',
        sequence: 2,
        jsonData: null,
        isActive: true,
        isDefault: true,
        userCheckEnrollCodeModel: null,
        revertAtTime: null
      }]
  };
  isSequence1Added: boolean = false;
  isPasscodeEdit = false;
  isgetPasscodeInfo = false;
  cellVal = '';
  emailVal = '';

  passCodeSourceTypeData = {
    sms: '',
    email: '',
    isSms1FA: true,
    isSms2FA: true,
  }

  yubikeyModelData = {
    key: ''
  }

  userCodeModelData = {
    code: ''
  }

  hardwareModelData = {
    serialId: '',
    source: '',
    code: '',
    recipient: ''
  }

  userCheckEnrollCode: UserCheckEnrollCodeModel = {
    enrollUrl: '',
    checkCode: ''
  }
  isReadyStatus = false;
  secretPushCode!: string;
  isModalHidden = true;
  isSavingPrimary: boolean = false;
  isSavingSecondary: boolean = false;
  disableUpdate: boolean = false;
  selectedUserType = "user";

  currentFirstFactor!: string;
  currentSecondFactor!: string;

  authEnforcementSequence!: number;
  authEnforcementType!: string;

  fidoAllowMultiple!: boolean;
  fidoAllowUsernameless!: boolean;

  minRevertAt: string = new Date().toISOString().slice(0, new Date().toISOString().lastIndexOf(":"));
  maxRevertAt: string;


  get primaryMethod(): FormControl {
    return this.enrollmentFormPrimary?.get('method') as FormControl;
  }

  get secondaryMethod(): FormControl {
    return this.enrollmentFormSecondary?.get('method') as FormControl;
  }

  get passcode(): FormGroup {
    return this.enrollmentFormPrimary.get('passcode') ?
      this.enrollmentFormPrimary?.get('passcode') as FormGroup : this.enrollmentFormSecondary.get('passcode') as FormGroup;
  }

  get passcodeMethod(): FormControl {
    return this.passcode?.get('passcodeMethod') as FormControl;
  }

  get email(): FormControl {
    return this.passcode?.get('email') as FormControl;
  }

  get sms(): FormControl {
    return this.passcode?.get('sms') as FormControl;
  }

  get pushSoftToken(): FormGroup {
    return this.enrollmentFormPrimary.get('pushSoftToken') ?
      this.enrollmentFormPrimary.get('pushSoftToken') as FormGroup : this.enrollmentFormSecondary.get('pushSoftToken') as FormGroup;
  }

  get checkCode(): FormControl {
    return this.pushSoftToken?.get('checkCode') as FormControl;
  }

  get yubikey(): FormGroup {
    return this.enrollmentFormPrimary.get('yubikey') ?
      this.enrollmentFormPrimary.get('yubikey') as FormGroup : this.enrollmentFormSecondary.get('yubikey') as FormGroup;
  }

  get serialNumber(): FormControl {
    return this.yubikey?.get('serialNumber') as FormControl;
  }

  get staticCode(): FormGroup {
    return this.enrollmentFormPrimary.get('staticCode') ?
      this.enrollmentFormPrimary.get('staticCode') as FormGroup : this.enrollmentFormSecondary.get('staticCode') as FormGroup;
  }

  get staticCodeInput(): FormControl {
    return this.staticCode?.get('staticCodeInput') as FormControl;
  }

  get hardware(): FormGroup {
    return this.enrollmentFormPrimary.get('hardware') ?
      this.enrollmentFormPrimary.get('hardware') as FormGroup : this.enrollmentFormSecondary.get('hardware') as FormGroup;
  }

  get hardwareToken(): FormControl {
    return this.hardware?.get('hardwareToken') as FormControl;
  }

  get passcodeGroup(): FormGroup {
    return this.fb.group({
      passcodeMethod: [null, Validators.compose([Validators.required])],
      email: [null],
      sms: [null],
    });
  }

  get pushSoftTokenGroup(): FormGroup {
    return this.isForLoggedInUser ? this.fb.group({ checkCode: ['', Validators.compose([Validators.required])] }) : this.fb.group({ checkCode: [''] });
  }

  get yubikeyGroup(): FormGroup {
    return this.fb.group({
      serialNumber: [null, Validators.compose([Validators.required, Validators.minLength(12)])]
    });
  }

  get staticCodeGroup(): FormGroup {
    return this.fb.group({
      staticCodeInput: [null, Validators.compose([Validators.required, Validators.minLength(this.allowUserCodeLength), Validators.pattern(this.options.validators.regOnlyNumber)])]
    });
  }

  get hardwareGroup(): FormGroup {
    return this.fb.group({
      hardwareToken: [null, Validators.compose([Validators.required])]
    });
  }

  get fidoTokenGroup(): FormGroup {
    return this.fb.group({
      fidoCredential: [null],
      fidoBackupMethod: [null],
      fidoBackupData: [null]
    });
  }

  get fidoToken(): FormGroup {
    return this.enrollmentFormPrimary.get('fidoToken') ?
      this.enrollmentFormPrimary?.get('fidoToken') as FormGroup : this.enrollmentFormSecondary.get('fidoToken') as FormGroup;
  }

  get fidoCredential(): FormControl {
    return this.fidoToken?.get('fidoCredential') as FormControl;
  }

  get fidoBackupMethod(): FormControl {
    return this.fidoToken?.get('fidoBackupMethod') as FormControl;
  }

  get fidoBackupData(): FormControl {
    return this.fidoToken?.get('fidoBackupData') as FormControl;
  }


  get disablePrimarySave(): boolean {
    return this.enrollmentFormPrimary.invalid || this.disableUpdate || this.isSavingPrimary || this.buttonDisabled || this.defaultAuthType == '' || (this.passCodeSourceTypeData.isSms1FA && !this.isSmsEnable && !!this.passcode) || !this.options.user.isActive;
  }

  get disableSecondarySave(): boolean {
    return this.enrollmentFormSecondary.invalid || this.disableUpdate || this.isSavingSecondary || this.buttonDisabled || this.defaultAuthType2FA == '' || (this.passCodeSourceTypeData.isSms2FA && !this.isSmsEnable && !!this.passcode) || !this.options.user.isActive;
  }

  constructor(
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private ngbModal: NgbModal,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
  ) {
    let date = new Date();
    date.setDate(date.getDate() + 7);
    date.setUTCHours(23, 59, 59, 999);
    this.maxRevertAt = date.toISOString().slice(0, new Date().toISOString().lastIndexOf(":"));
  }

  ngOnInit() {    

    if(!this.options.style.saveButtonClass) {
      this.options.style.saveButtonClass = "btn btn-primary";
    }

    this.enrollmentFormPrimary = this.fb.group({
      method: [{ value: null, disabled: this.options.state.disablePrimaryFactor }],
      isTemp: [false],
      tempRevertAt: [this.getDefaultTempDate(), [Validators.required, EnrollmentComponent.dateAfterTodayValidator, EnrollmentComponent.dateWithinAWeekValidator]]
    });
    this.enrollmentFormPrimary.controls.tempRevertAt.disable();
    this.enrollmentFormSecondary = this.fb.group({
      method: [null],
      isTemp: [false],
      tempRevertAt: [this.getDefaultTempDate()]
    });
    this.enrollmentFormSecondary.controls.tempRevertAt.disable();

    this.loginUsername = this.options.currentUser.username;
    if (this.options.user.username === this.loginUsername) {
      this.isForLoggedInUser = true;
    }
    this.pushEnabled = true;
    this.authUserType = this.options.currentUser.type;

    if (!this.isForLoggedInUser) {
      this.selectedUserType = this.options.user.type;
    }

    if (this.options.state.hidePrimaryFactor) {
      this.secondFactorAllow();
    }
    this.getMFASettings(this.options.org.id);
    this.getIsUserPasswordExists();

    this.subscriptions.add(this.primaryMethod.valueChanges.subscribe((method) => {
      this.showOption(method, 1, null);
    }));

    this.subscriptions.add(this.secondaryMethod.valueChanges.subscribe((method) => {
      this.showOption(method, 2, null);
    }));

    this.getAuthEnforcement();

  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getDefaultTempDate(): string {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    return this.toDateString(date);
  }

  toDateString(date: Date): string {
    return (date.getFullYear().toString() + '-' 
       + ("0" + (date.getMonth() + 1)).slice(-2) + '-' 
       + ("0" + (date.getDate())).slice(-2))
       + 'T' + date.toTimeString().slice(0,5);
}

  //ngOnChanges(changes: SimpleChanges) {
    //if (changes['disablePrimaryFactor'] && this.primaryMethod) {
      //this.options.state.disablePrimaryFactor = changes['disablePrimaryFactor'].currentValue;
      //this.options.state.disablePrimaryFactor ? this.primaryMethod.disable() : this.primaryMethod.enable();
    //}
    //if (changes['username']) {
      //this.options.user.username = changes['username'].currentValue;
    //}
  //}

  setupOptions() {
    this.fidoOptions = {
      state: {
        isForLoggedInUser: this.isForLoggedInUser,
        allowMultipleTokens: this.fidoAllowMultiple,
        allowResidentKey: this.fidoAllowUsernameless,
      },
      org: {
        id: this.options.org.id,
        name: this.options.org.mnemonic
      },
      user: {
        username: this.options.user.username,
      },
      validators: {
        smsValidator: this.options.validators.regPhoneNumber,
        emailValidator: this.options.validators.regEmail
      },
      functions: this.options.functions.fido,
      modals: this.options.modals.fido
    }


    this.softtokenOptions = {
      state: {
        pushEnabled: this.pushEnabled,
        pushEnforced: this.pushEnforced,
        pushAllowed: this.pushAllowed,
        authenticatorType: this.softTokenType
      },
      functions: this.options.functions.softtoken,
      validators: this.options.validators.softtoken
    }
  }

  getAuthEnforcement(): void {
    this.subscriptions.add(this.options.functions.getUserAuthStatus(this.options.org.mnemonic, this.options.user.username).subscribe((data: any) => {
      if (data == null) {
        return;
      }
      this.authEnforcementSequence = data.sequence;
      this.authEnforcementType = data.authenticationTypeName;
    }));
  }

  getIsUserPasswordExists() {
    // User enrollemt from normal User - don't check for password login - as its obvious that user is logged in with primary auth method
    if (this.options.state.skipPasswordPresence) {
      this.getAuthMethods(this.options.org.id, this.options.user.id);
    } else {
      // User enrollemt from admin/helpdesk users - check for password login from user
      this.subscriptions.add(this.options.functions.doesUserPasswordExist(this.options.user.id).subscribe(
        (data:any) => {
          if (data === true) {
            this.getAuthMethods(this.options.org.id, this.options.user.id);
          }
          else {
            this.toastrService.error(this.translateService.instant('Enrollment.UserPasswordLoginError'), '', { timeOut: 8000 });
          }
        }));
    }
  }

  getMFASettings(orgId: number) {
    this.subscriptions.add(this.options.functions.getOrgSettings(this.options.org.id, 'MFA').subscribe((data: any) => {
      this.allowUserCodeLength = JSON.parse(data.find((x: any) => x.key == 'UserCodeFormat')?.value).MinimumLength;
      this.fidoAllowMultiple = JSON.parse(data.find((x: any) => x.key == 'FidoAllowMultiple')?.value ?? 'false');
      this.fidoAllowUsernameless = JSON.parse(data.find((x: any) => x.key == 'FidoAllowResidentKey')?.value ?? 'false');
      this.softTokenType = data.find((x: any) => x.key == 'SoftTokenAuthenticatorType')?.value ?? 'securenvoy';
      this.pushAllowed = !JSON.parse(data.find((x: any) => x.key == 'DisableSoftTokenPush')?.value ?? 'false');
      this.setupOptions();
    }));
  }

  getAuthMethods(orgId: number, userId: number) {
    this.subscriptions.add(this.options.functions.getAuthMethods(orgId, userId).subscribe(
      (data: any) => {
        if (data == null) {
          this.secondAuthenticationMethod = Object.keys(this.authenticationMethod);
          this.allowChangeInfo(this.secondAuthenticationMethod);
        }
        else {
          const config = data as AuthenticationMethodConfiguration;
          this.authMethodConfig = config;
          if(config.enforcePush) {
            this.pushEnforced = true;
            this.softTokenType = 'securenvoy';
          }

          this.secondAuthenticationMethod = [];
          this.secondAuthenticationMethod.push(this.authenticationMethod.Password);
          if(this.checkMethodAllowed(config.passcode)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.PassCode);
          }

          if(this.checkMethodAllowed(config.staticCode)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.UserCode);
          }

          if(this.checkMethodAllowed(config.softToken)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.Push);
          }

          if(this.checkMethodAllowed(config.hardwareToken)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.Hardware);
          }

          if(this.checkMethodAllowed(config.yubikey)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.Yubikey);
          }

          if(this.checkMethodAllowed(config.fidoToken)) {
            this.secondAuthenticationMethod.push(this.authenticationMethod.FidoToken);
          }

          this.allowChangeInfo(this.secondAuthenticationMethod);
          
          this.allowSecondFactor = config.allowSecondFactor;
          this.secondFactorEnforce = config.enforceSecondFactor;
          this.isSmsEnable = config.passcodeViaSms;
          this.isEmailEnable = config.passcodeViaEmail;         
        }

        this.checkRecordExistance();
      }));
  }

  checkMethodAllowed(method: AuthenticationMethodFlags) {
    if((method & AuthenticationMethodFlags.Enabled) === AuthenticationMethodFlags.Enabled) {
      if(this.isForLoggedInUser && this.authUserType != 'superadmin' && this.authUserType != 'mspadmin' && this.authUserType != 'adminuser') {
        if((method & AuthenticationMethodFlags.UserSelectable) === AuthenticationMethodFlags.UserSelectable) {
          return true;
        }
        return false;
      }
      return true;
    }
    return false;
  }

  checkMethodAllowedForTemp(factor: {enrollmentFormGroup:FormGroup, enrollmentType: string}) {
    const method = factor.enrollmentFormGroup.value.method;
    let currentMethod: string | null = null;
    if(factor.enrollmentType == 'primary') {
      currentMethod = this.currentFirstFactor;
    } else if(factor.enrollmentType == 'secondary') {
      currentMethod = this.currentSecondFactor;
    }

    if(!currentMethod) {
      return false;
    }
    if(currentMethod == AuthenticationMethod.Push && method == AuthenticationMethod.Push) {
      return false;
    }   
    return this.isMethodStringAllowedForTemp(method);
    
  }
  isMethodStringAllowedForTemp(method: string): boolean {
    switch (method) {
      case AuthenticationMethod.Password: {
        return false;
      }
      case AuthenticationMethod.PassCode: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.passcode);
      }
      case AuthenticationMethod.UserCode: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.staticCode);
      }
      case AuthenticationMethod.Push: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.softToken);
      }
      case AuthenticationMethod.Hardware: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.hardwareToken);
      }
      case AuthenticationMethod.Yubikey: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.yubikey);
      }
      case AuthenticationMethod.FidoToken: {
        return this.isMethodFlagAllowedForTemp(this.authMethodConfig.fidoToken);
      }
      default: {
        return false;
      }
    }
  }

  isMethodFlagAllowedForTemp(method: AuthenticationMethodFlags): boolean {
    return (method & AuthenticationMethodFlags.AllowedAsTemp) === AuthenticationMethodFlags.AllowedAsTemp;
  }

  changeIsTemp(form: FormGroup) {
    if(form.value.isTemp) {
      form.controls.isTemp.setValue(false);
      form.controls.tempRevertAt.disable();
    } else {
      form.controls.isTemp.setValue(true);
      form.controls.tempRevertAt.enable();
    }      
  }

  allowChangeInfo(authenticationMethod: string[]) {
    if (authenticationMethod && authenticationMethod.length > 0) {
      if (authenticationMethod.length === 1) {
        if (authenticationMethod[0] === AuthenticationMethod.Yubikey) {
          this.buttonDisabled = true;
        }
        else {
          this.buttonDisabled = false;
        }
      }
      else {
        this.buttonDisabled = false;
      }
    }
  }

  checkRecordExistance() {
    if (this.isForLoggedInUser) {
      this.subscriptions.add(this.options.functions.getAllAuthTypes().subscribe(
        (data: any) => {
          this.setUserAuthType(data);
        }));
    } else {
      this.subscriptions.add(this.options.functions.getAuthTypesForUser(this.options.user.username, this.options.org.mnemonic).subscribe((data: any) => {
        this.setUserAuthType(data);
      }));
    }
  }

  setUserAuthType(data: any) {
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        this.existingUserAuthenticationType(data[i]);
        if (data[i].sequence === 1) {
          this.authTypeName = data[i].authenticationTypeName;
          this.currentFirstFactor = data[i].authenticationTypeName;
          this.authenticationTypeModel.UserAuthenticationTypeModelList[0] = data[i];
          if(data[i].revertAtTime) {
            this.enrollmentFormPrimary.controls.isTemp.setValue(true);
            this.enrollmentFormPrimary.controls.tempRevertAt.enable();
            this.enrollmentFormPrimary.controls.tempRevertAt.setValue(this.toDateString(new Date(data[i].revertAtTime)));
          }
          
        }
        else {
          if (data.length == 1) {
            this.showOption(AuthenticationMethod.Password, 1, null);
          }

          this.authTypeName2FA = data[i].authenticationTypeName;
          this.currentSecondFactor = data[i].authenticationTypeName;
          this.authenticationTypeModel.UserAuthenticationTypeModelList[1] = data[i];
          if(data[i].revertAtTime) {
            this.enrollmentFormSecondary.controls.isTemp.setValue(true);
            this.enrollmentFormSecondary.controls.tempRevertAt.enable();
            this.enrollmentFormSecondary.controls.tempRevertAt.setValue(this.toDateString(new Date(data[i].revertAtTime)));
          }
        }
      }
    } else {
      this.showOption(AuthenticationMethod.Password, 1, null);
    }
    if (!this.isSequence1Added) {
      this.showOption(AuthenticationMethod.Password, 1, null);
    }
  }

  existingUserAuthenticationType(model: any) {
    if (model.sequence === 2 && model.isActive === true) {
      this.disableSecondFactor = false;
    }

    const response = model;
    if (response.jsonData == null || model.authenticationTypeName.toLowerCase() === this.authenticationMethod.Push.toLowerCase()) {
      this.authTypeData = null;
    }
    else {
      this.authTypeData = JSON.parse(response.jsonData);
    }

    if (response.authenticationTypeName && response.authenticationTypeName.toLowerCase() !== this.authenticationMethod.PassCode.toLowerCase()) {
      this.showOption(response.authenticationTypeName, response.sequence, model);
    }
    else {
      this.isPasscodeEdit = true;
      this.getUserEmailandSMS(response.authenticationTypeName, response.sequence, model);
    }

    if (response.authenticationTypeName.toLowerCase() === this.authenticationMethod.PassCode.toLowerCase()) {
      const methodType = response.sequence + 'FA'
      this.passcodeAuthType(this.authTypeData.source, methodType);
    }
    else if (response.authenticationTypeName.toLowerCase() === this.authenticationMethod.Yubikey.toLowerCase()) {
      this.yubikeyAuthType();
    }
    else if (response.authenticationTypeName.toLowerCase() === this.authenticationMethod.UserCode.toLowerCase()) {
      this.userCodeAuthType();
    }
    else if (response.authenticationTypeName.toLowerCase() === this.authenticationMethod.Hardware.toLowerCase()) {
      this.isEdit = true;
    }
  }

  getUserEmailandSMS(authenticationTypeName: string, sequence: number, model: any) {
    if (!this.isgetPasscodeInfo) {
      this.isgetPasscodeInfo = true;
      this.callUserPasscodeInfo(authenticationTypeName, sequence, model);
    }
    else {
      this.showOption(authenticationTypeName, sequence, model);
    }
  }


  callUserPasscodeInfo(authenticationTypeName: string, sequence: number, model: any) {
    let apiToCall = this.options.functions.getBasicUserInfo;
    this.subscriptions.add(apiToCall(this.options.user.username, this.options.org.id).subscribe(
      (data:any) => {
        if (data) {
          this.cellVal = data.cell;
          this.emailVal = data.email;
        }
        if (this.passCodeSourceTypeData.sms === '' && this.passCodeSourceTypeData.email === '') {
          this.passCodeSourceTypeData.sms = this.cellVal;
          this.passCodeSourceTypeData.email = this.emailVal;
          if (this.passcode) {
            if (this.sms) {
              this.sms.setValue(this.passCodeSourceTypeData.sms);
            }
            if (this.email) {
              this.email.setValue(this.passCodeSourceTypeData.email);
            }
          }
        }
        if (this.isPasscodeEdit) {
          this.showOption(authenticationTypeName, sequence, model);
        }
      }));
  }

  passcodeAuthType(type: string, methodType: string) {
    if (methodType === '1FA') {
      if (type.toLowerCase() === PassCodeSourceType.Sms.toLowerCase()) {
        this.passCodeSourceTypeData.isSms1FA = true;
      }
      else {
        this.passCodeSourceTypeData.isSms1FA = false;
      }
    }
    else if (methodType === '2FA') {
      if (type.toLowerCase() === PassCodeSourceType.Sms.toLowerCase()) {
        this.passCodeSourceTypeData.isSms2FA = true;
      }
      else {
        this.passCodeSourceTypeData.isSms2FA = false;
      }
    }

    if (this.authTypeData) {
      if (this.authTypeData.source.toLowerCase() === PassCodeSourceType.Sms.toLowerCase()) {
        this.passCodeSourceTypeData.sms = this.authTypeData.recipient;
        if (this.sms) {
          this.sms.setValue(this.passCodeSourceTypeData.sms);
        }
      }
      else if (this.authTypeData.source.toLowerCase() === PassCodeSourceType.Email.toLowerCase()) {
        this.passCodeSourceTypeData.email = this.authTypeData.recipient;
        if (this.email) {
          this.email.setValue(this.passCodeSourceTypeData.email);
        }
      }
    }

    if (type.toLowerCase() === PassCodeSourceType.Sms.toLowerCase()) {
      if (this.email) {
        this.email.setValidators([]);
        this.email.disable();
      }
      if (this.sms) {
        this.sms.enable();
        this.sms.setValidators(Validators.compose([Validators.required, Validators.pattern(this.options.validators.regPhoneNumber)]));
      }
    } else {
      if (this.sms) {
        this.sms.setValidators([]);
        this.sms.disable();
      }
      if (this.email) {
        this.email.enable();
        this.email.setValidators(Validators.compose([Validators.required, Validators.pattern(this.options.validators.regEmail)]));
      }
    }
    if (this.email) {
      this.email.updateValueAndValidity();
    }
    if (this.sms) {
      this.sms.updateValueAndValidity();
    }

  }

  yubikeyAuthType() {
    this.yubikeyModelData.key = this.authTypeData.code;
  }

  userCodeAuthType() {
    this.userCodeModelData.code = this.authTypeData.code;
  }

  async showOption(type: string, sequence: number, model: any) {
    if (sequence === 1) {
      this.defaultAuthType = this.authenticationTypeModel.UserAuthenticationTypeModelList[0].authenticationTypeName = type;
      if (model == null) {
        model = this.authenticationTypeModel.UserAuthenticationTypeModelList[0];
      }
      this.isSequence1Added = true;
      this.primaryMethod.setValue(type, { onlySelf: true, emitEvent: false });

      if(type != this.currentFirstFactor) {
        this.enrollmentFormPrimary.controls.isTemp.setValue(false);
            this.enrollmentFormPrimary.controls.tempRevertAt.setValue(this.getDefaultTempDate());
            this.enrollmentFormPrimary.controls.tempRevertAt.disable();
      }

      this.buildForm(type, 'Primary');
    } else {
      this.defaultAuthType2FA = this.authenticationTypeModel.UserAuthenticationTypeModelList[1].authenticationTypeName = type;
      if (model == null) {
        model = this.authenticationTypeModel.UserAuthenticationTypeModelList[1];
      }
      this.secondaryMethod.setValue(type, { onlySelf: true, emitEvent: false });

      if(type != this.currentSecondFactor) {
        this.enrollmentFormSecondary.controls.isTemp.setValue(false);
            this.enrollmentFormSecondary.controls.tempRevertAt.setValue(this.getDefaultTempDate());
            this.enrollmentFormSecondary.controls.tempRevertAt.disable();
      }

      this.buildForm(type, 'Secondary');
    }
    if (type) {
      type = type.toLowerCase();
    }

    if (this.authenticationTypeModel?.UserAuthenticationTypeModelList[0]?.authenticationTypeName?.toLowerCase() !== AuthenticationMethod.Push.toLowerCase()
      && this.authenticationTypeModel?.UserAuthenticationTypeModelList[1]?.authenticationTypeName?.toLowerCase() !== AuthenticationMethod.Push.toLowerCase()) {

      this.userCheckEnrollCode.checkCode = '';
      this.isReadyStatus = false;
    }

    this.fidoCredential?.clearValidators();
    this.fidoBackupMethod?.clearValidators();
    this.fidoBackupData?.clearValidators();

    if (AuthenticationMethod.PassCode.toLowerCase() === type) {
      if (model.authenticationTypeId <= 0 || this.authTypeData == null) {
        this.authTypeData = {
          auth_type: AuthenticationMethod.PassCode,
          source: '',
          recipient: ''
        }
        this.passCodeSourceTypeData.sms = this.cellVal;
        this.passCodeSourceTypeData.email = this.emailVal;
      }
      else if (this.authTypeData != null) {
        if (this.authTypeData.auth_type.toLowerCase() !== type) {
          this.authTypeData = {
            auth_type: AuthenticationMethod.PassCode,
            source: '',
            recipient: ''
          }
          if (this.passCodeSourceTypeData.sms == null || this.passCodeSourceTypeData.sms === '') {
            this.passCodeSourceTypeData.sms = this.cellVal;
          }
          else if (this.passCodeSourceTypeData.email == null || this.passCodeSourceTypeData.email === '') {
            this.passCodeSourceTypeData.email = this.emailVal;
          }
        }
        else {
          if (this.passCodeSourceTypeData.sms == null || this.passCodeSourceTypeData.sms === '') {
            this.passCodeSourceTypeData.sms = this.cellVal;
          }
          else if (this.passCodeSourceTypeData.email == null || this.passCodeSourceTypeData.email === '') {
            this.passCodeSourceTypeData.email = this.emailVal;
          }
        }
      }

      if (this.passCodeSourceTypeData.sms === '' && this.passCodeSourceTypeData.email === '') {
        this.getUserEmailandSMS(AuthenticationMethod.PassCode, sequence, null);
      } else {
        this.sms.setValue(this.passCodeSourceTypeData.sms);
        this.email.setValue(this.passCodeSourceTypeData.email);
      }

      if (this.passcode) {

        if ((sequence == 1 && this.passCodeSourceTypeData.isSms1FA) || (sequence == 2 && this.passCodeSourceTypeData.isSms2FA)) {
          this.passcodeMethod.setValue('SMS');
        } else {
          this.passcodeMethod.setValue('Email');
        }
        this.email.updateValueAndValidity();
        this.sms.updateValueAndValidity();
      }
    }
    else if (AuthenticationMethod.Push.toLowerCase() === type) {
      if (this.isForLoggedInUser) {

      }
    }

    else if (AuthenticationMethod.Yubikey.toLowerCase() === type) {
      if (model.authenticationTypeId <= 0 || this.authTypeData == null) {
        this.authTypeData = {
          auth_type: AuthenticationMethod.Yubikey,
          code: ''
        }
      } else if (this.authTypeData != null) {
        if (this.authTypeData.auth_type.toLowerCase() !== type) {
          this.authTypeData = {
            auth_type: AuthenticationMethod.Yubikey,
            code: ''
          }
        }
      }
      this.serialNumber.setValue(this.yubikeyModelData.key !== '' ? this.yubikeyModelData.key : this.authTypeData.code);
    }

    else if (AuthenticationMethod.UserCode.toLowerCase() === type) {
      if (model.authenticationTypeId <= 0 || this.authTypeData === null) {
        this.authTypeData = {
          auth_type: AuthenticationMethod.UserCode,
          source: 'Static',
          code: ''
        }
      }
      else if (this.authTypeData !== null) {
        if (this.authTypeData.auth_type === null || this.authTypeData.auth_type && this.authTypeData.auth_type.toLowerCase() !== type) {
          this.authTypeData = {
            auth_type: AuthenticationMethod.UserCode,
            source: 'Static',
            code: ''
          }
        }
      }
      this.staticCodeInput.setValue(this.userCodeModelData.code !== '' ? this.userCodeModelData.code : this.authTypeData.code);
    }
    else if (AuthenticationMethod.Hardware.toLowerCase() === type) {
      this.loadHardwareTokens();
      if (model.authenticationTypeId <= 0 || this.authTypeData === null) {
        this.authTypeData = {
          auth_type: AuthenticationMethod.Hardware,
          source: '',
          code: '',
          recipient: ''
        }
      }
      else if (this.authTypeData !== null) {
        if (this.authTypeData.auth_type === null || this.authTypeData.auth_type && this.authTypeData.auth_type.toLowerCase() !== type) {
          this.authTypeData = {
            auth_type: AuthenticationMethod.Hardware,
            source: '',
            code: '',
            recipient: ''
          }
        }
      }
    }
    else if (AuthenticationMethod.FidoToken.toLowerCase() === type) {


      await new Promise(r => setTimeout(r, 100));
      let currentAuthType;
      if (sequence == 1) {
        currentAuthType = this.currentFirstFactor;
      } else {
        currentAuthType = this.currentSecondFactor;
      }

      if (this.isForLoggedInUser || currentAuthType == 'FidoToken') {
        this.fidoCredential.setValidators(Validators.required);
        this.fidoCredential.updateValueAndValidity();
        this.fidoBackupMethod.setValidators(Validators.required);
        this.fidoBackupMethod.updateValueAndValidity();
        this.fidoBackupData.setValidators(Validators.required);
        this.fidoBackupData.updateValueAndValidity();
      }

      if (currentAuthType == 'FidoToken') {

        this.authTypeData = JSON.parse(model.jsonData);
        this.authTypeData.auth_type = 'FidoToken';
        this.fidoTokenComponent.setValue(this.authTypeData);
      } else {
        if (this.isForLoggedInUser) {
          //this.fidoTokenComponent.registerFidoToken();
        }
      }
    }
  }

  buildForm(method: any, enrollmenttype: string) {
    let enrollmentForm;

    if (enrollmenttype === 'Primary') {
      enrollmentForm = 'enrollmentFormPrimary';
    } else {
      enrollmentForm = 'enrollmentFormSecondary';
    }

    this[enrollmentForm].removeControl('passcode');
    this[enrollmentForm].removeControl('pushSoftToken');
    this[enrollmentForm].removeControl('yubikey');
    this[enrollmentForm].removeControl('staticCode');
    this[enrollmentForm].removeControl('hardware');

    switch (method) {
      case 'PassCode': {
        this[enrollmentForm].addControl('passcode', this.passcodeGroup);
        this.subscriptions.add(this.passcodeMethod.valueChanges.subscribe((passcodeMethod) => {
          if (passcodeMethod === 'SMS') {
            this.email.setValidators([]);
            this.email.disable();
            this.sms.enable();
            this.sms.setValidators(Validators.compose([Validators.required, Validators.pattern(this.options.validators.regPhoneNumber), Validators.minLength(6)]));
          }

          if (passcodeMethod === 'Email') {
            this.sms.setValidators([]);
            this.sms.disable();
            this.email.enable();
            this.email.setValidators(Validators.compose([Validators.required, Validators.pattern(this.options.validators.regEmail)]));
          }
          this.email.updateValueAndValidity();
          this.sms.updateValueAndValidity();
        }));
        break;
      }
      case 'Push': {
        this[enrollmentForm].addControl('pushSoftToken', this.pushSoftTokenGroup);
        break;
      }
      case 'Yubikey': {
        this[enrollmentForm].addControl('yubikey', this.yubikeyGroup);
        break;
      }
      case 'UserCode': {
        this[enrollmentForm].addControl('staticCode', this.staticCodeGroup);
        break;
      }
      case 'Hardware': {
        this[enrollmentForm].addControl('hardware', this.hardwareGroup);
        this.subscriptions.add(this.hardwareToken.valueChanges.subscribe((hardwareToken) => {
          this.tokenChange(hardwareToken);
        }));
        break;
      }
      case 'FidoToken': {
        this[enrollmentForm].addControl('fidoToken', this.fidoTokenGroup);
      }
    }
  }

  loadHardwareTokens() {
    this.subscriptions.add(this.options.functions.getHardwareTokens(this.options.org.id, this.options.user.username).subscribe(
      (data: any) => {
        this.tokens = data;
        this.tokensBuffer = this.tokens.slice(0, this.bufferSize);
        if (this.isEdit) {
          this.hardwareAuthType();
        }
      }));
  }

  hardwareAuthType() {
    const element = this.tokens.find((element: any) => element.type === +this.authTypeData.source && element.seed === this.authTypeData.code && element.id === +this.authTypeData.recipient);
    this.tokenChange(element);
    this.hardwareToken.setValue(element);
  }

  tokenChange(item: any) {
    if (item) {
      this.hardwareModelData.serialId = item.serialId;
      this.hardwareModelData.source = item.type;
      this.hardwareModelData.code = item.seed;
      this.hardwareModelData.recipient = item.id;
    }
  }

  onSearch(event: any) {
    if (event.term === '') {
      this.tokensBuffer = this.tokens.slice(0, this.bufferSize);
    }
    else {
      const records = this.tokens.filter((x: any) => x.serialId.indexOf(event.term) !== -1);
      this.tokensBuffer = records;
    }
  }

  onScroll({ end }: any) {
    if (this.loading || this.tokens.length <= this.tokensBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.tokensBuffer.length) {
      this.fetchMoreTokens();
    }
  }

  removeOverlay() {
    const overlay = document.getElementById(`overlay`);
    if(overlay) {overlay.style.display = 'none';}   
  }

  enlargeImage() {
    this.isModalHidden = false;
  }

  closeQRImage() {
    this.isModalHidden = true;
  }

  secondFactorAllow() {
    if(this.secondFactorEnforce && this.isForLoggedInUser) {
      this.disableSecondFactor = false;
      return;
    }
    this.disableSecondFactor = !this.disableSecondFactor;
    if (this.disableSecondFactor === false) {
      this.showOption(this.authenticationTypeModel.UserAuthenticationTypeModelList[1].authenticationTypeName, 2, this.authenticationTypeModel.UserAuthenticationTypeModelList[1]);
    }
    else {
      if (this.defaultAuthType2FA === '') {
        return;
      }
      this.defaultAuthType2FA = '';
      const modalRef = this.ngbModal.open(SecondFaModal, {
        size: 'md',
        windowClass: 'fadeInUp animated huge',
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.isMfaEnforced = this.secondFactorEnforce;
      modalRef.result
        .then((result: any) => {
          if (result === 'yes') {
            let apiToCall = this.options.functions.deactivateSecondFactor(this.options.user.username, this.options.org.mnemonic);
            this.subscriptions.add(apiToCall.subscribe({
              next: () => {
                this.toastrService.success(this.translateService.instant('Action.Success'));
                this.authenticationTypeModel.UserAuthenticationTypeModelList[1] = {
                  authenticationTypeId: 0,
                  authenticationTypeName: '',
                  userName: '',
                  organizationMnemonic: '',
                  sequence: 2,
                  jsonData: null,
                  isActive: true,
                  isDefault: true,
                  userCheckEnrollCodeModel: null,
                  revertAtTime: null
                }
              },
              error: () => { },
              complete: () => { }
            }));
          }
          else {
            this.disableSecondFactor = false;
            this.showOption(this.authenticationTypeModel.UserAuthenticationTypeModelList[1].authenticationTypeName, 2,
              this.authenticationTypeModel.UserAuthenticationTypeModelList[1]);
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
    }
  }

  private fetchMoreTokens() {
    const length = this.tokensBuffer.length;
    const remainingData = this.tokens.slice(length, this.bufferSize + length);
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.tokensBuffer = this.tokensBuffer.concat(remainingData);
    }, 200)
  }


  saveOrUpdate(enrollmentType: any) {
    let enrollmentMethod, sequence, savingFlag: string, modelName, index, revertAt: Date | null;
    if (enrollmentType === 'primary') {
      enrollmentMethod = this.primaryMethod.value.toLowerCase();
      sequence = 1;
      savingFlag = 'isSavingPrimary';
      modelName = 'UserAuthenticationTypeModelList';
      index = 0;
      revertAt = this.enrollmentFormPrimary.value.isTemp && this.isMethodStringAllowedForTemp(enrollmentMethod) ? new Date(this.enrollmentFormPrimary.value.tempRevertAt) : null;
    } else {
      enrollmentMethod = this.secondaryMethod.value.toLowerCase();
      sequence = 2;
      savingFlag = 'isSavingSecondary';
      modelName = 'UserAuthenticationTypeModelList';
      index = 1;
      revertAt = this.enrollmentFormSecondary.value.isTemp && this.isMethodStringAllowedForTemp(enrollmentMethod) ? new Date(this.enrollmentFormSecondary.value.tempRevertAt) : null;
    }

    this[savingFlag] = true;
    if (!this.isForLoggedInUser && enrollmentMethod === AuthenticationMethod.Push.toLowerCase()) {
      const authEnforcement: any = {};
      const userData: any = {};
      authEnforcement.authenticationTypeName = AuthenticationMethod.Push;
      authEnforcement.sequence = sequence;
      userData.username = this.options.user.username;
      userData.authEnforcement = JSON.stringify(authEnforcement);
      this.subscriptions.add(this.options.functions.updateUserAuthStatus(this.options.org.mnemonic, userData).subscribe({
        next: () => {
          this.toastrService.success(this.translateService.instant('Action.Success'));
          this[savingFlag] = false;
        },
        error: () => {
          this.toastrService.error(this.translateService.instant('Action.Error'), '', { timeOut: 8000 });
          this[savingFlag] = false;
        },
        complete: () => { }
      }
      ));
    }
    else if (!this.isForLoggedInUser && ((sequence == 1 && this.currentFirstFactor != 'FidoToken') || (sequence == 2 && this.currentSecondFactor != 'FidoToken')) && enrollmentMethod === AuthenticationMethod.FidoToken.toLowerCase()) {
      const authEnforcement: any = {};
      const userData: any = {};
      authEnforcement.authenticationTypeName = AuthenticationMethod.FidoToken;
      authEnforcement.sequence = sequence;
      userData.username = this.options.user.username;
      userData.authEnforcement = JSON.stringify(authEnforcement);

      this.subscriptions.add(this.options.functions.updateUserAuthStatus(this.options.org.mnemonic, userData).subscribe({
        next: () => {
          this.toastrService.success(this.translateService.instant('Action.Success'));
          this[savingFlag] = false;
          this.savedEnrollment.emit(true);
        },
        error: () => {
          this.toastrService.error(this.translateService.instant('Action.Error'), '', { timeOut: 8000 });
          this[savingFlag] = false;
        },
        complete: () => { }
      }
      ));
    }
    else {
      if (this.authEnforcementSequence > 0) {
        const userData: any = {};
        userData.username = this.options.user.username;
        userData.authEnforcement = null;
        this.subscriptions.add(this.options.functions.updateUserAuthStatus(this.options.org.mnemonic, userData).subscribe(data => {}));
      }
      switch (enrollmentMethod) {
        case AuthenticationMethod.Push.toLowerCase(): {
          if (this.isReadyStatus === true) {
            this.authenticationTypeModel[modelName][index].userCheckEnrollCodeModel = null;
          }
          else {
            this.authenticationTypeModel[modelName][index].userCheckEnrollCodeModel = this.userCheckEnrollCode;
          }
          this.authTypeData = null;
          this.authenticationTypeModel[modelName][index].pushEnabled = this.pushEnabled;
          break;
        }
        case AuthenticationMethod.PassCode.toLowerCase(): {
          this.authTypeData = {
            auth_type: AuthenticationMethod.PassCode,
            source: '',
            recipient: ''
          }
          this.authTypeData.recipient = this.passcodeMethod.value === 'SMS' ? this.sms.value : this.email.value;
          this.authTypeData.source = this.passcodeMethod.value === 'SMS' ? PassCodeSourceType.Sms : PassCodeSourceType.Email;
          break;
        }
        case AuthenticationMethod.Yubikey.toLowerCase(): {
          this.authTypeData.code = this.serialNumber.value.substring(0, 12);
          break;
        }
        case AuthenticationMethod.UserCode.toLowerCase(): {
          this.authTypeData = {
            auth_type: AuthenticationMethod.UserCode,
            source: 'Static',
            code: this.staticCodeInput.value
          }
          break;
        }
        case AuthenticationMethod.Hardware.toLowerCase(): {
          this.authTypeData = {
            auth_type: AuthenticationMethod.Hardware,
            source: this.hardwareModelData.source.toString(),
            code: this.hardwareModelData.code,
            recipient: this.hardwareModelData.recipient.toString()
          }
          break;
        }
        case AuthenticationMethod.Password.toLowerCase(): {
          this.authTypeData = null;
          break;
        }
        case AuthenticationMethod.FidoToken.toLowerCase(): {
          const creds = {
            attestations: this.fidoCredential.value,
            backup: {
              method: this.fidoBackupMethod.value,
              recipient: this.fidoBackupData.value
            }
          }
          this.authTypeData = creds;
        }
      }
      this.authenticationTypeModel[modelName][index].jsonData = this.authTypeData ? JSON.stringify(this.authTypeData) : this.authTypeData;
      //this.authenticationTypeModel[modelName][index].userName = this.isForLoggedInUser ? '' : this.options.user.username;
      this.authenticationTypeModel[modelName][index].userName = this.options.user.username;
      let model = this.authenticationTypeModel[modelName][index];

      if (revertAt) {
        model.revertAtTime = revertAt
      }
      else {
        model.revertAtTime = null;
      }

      if(this.isForLoggedInUser){
        this.subscriptions.add(this.options.functions.updateThisUserAuthType(model).subscribe({
          next: (data:any) => {
            if (data === true) {
              this.toastrService.success('User authentication is updated', 'Success');
              this[savingFlag] = false;
              this.savedEnrollment.emit(true);
            } else {
              this.toastrService.error('Failed to configure Secondary Factor', 'Error', { timeOut: 8000 });
              this[savingFlag] = false;
            }
          },
          error: () => {
            this.toastrService.error('Failed to configure Secondary Factor', 'Error', { timeOut: 8000 });
            this[savingFlag] = false;
          }
        }))
      }else{
        this.subscriptions.add(this.options.functions.updateOtherUserAuthType(this.options.org.mnemonic, model)
          .subscribe({
            next: () => {
              this.toastrService.success(this.translateService.instant('Action.Success'));
              this[savingFlag] = false;
              this.savedEnrollment.emit(true);
            },
            error: (e: any) => {
              if (e.error?.error instanceof SyntaxError == false) {
                this.toastrService.error(this.translateService.instant('Action.Error'), '', { timeOut: 8000 });
              }
              this[savingFlag] = false;
            },
            complete: () => { }
          }));
        }
      }

  }

  setFidoCredential(output: FidoCredentialOutput): void {
    this.fidoCredential?.setValue(output.attestation);
    this.fidoBackupMethod?.setValue(output.backupMethod);
    this.fidoBackupData?.setValue(output.backupData);
  }

  handleSoftTokenOutput(output: SoftTokenOutput) {
    this.userCheckEnrollCode.enrollUrl = output.enrolUrl;
    this.pushEnabled = output.pushEnabled;
    if (output.hasAutoEnrolled == true) {
      this.checkCode.disable();
      this.isReadyStatus = true;
      this.buttonDisabled = false;
      this.authTypeData = null;
    }
    else {
      this.checkCode.enable();
      this.checkCode.setValue(output.checkCode);
      this.userCheckEnrollCode.checkCode = output.checkCode;
    }


  }

  decode(value: string): string {
    if (value) {
      return atob(value);
    }
    return "";
  }

  static dateAfterTodayValidator(c: FormControl) {
    if (!c.value) {
      return null;
    }
    const today = new Date();
    let value = new Date(c.value);
    if (value > today) {
      return null;
    } else {
      return { dateAfterToday: { valid: false } };
    }
  }

  static dateWithinAWeekValidator(c: FormControl) {
    if (!c.value) {
      return null;
    }
    const date = new Date();
    date.setDate(date.getDate() + 7);
    let value = new Date(c.value);
    if (value <= date) {
      return null;
    } else {
      return { dateWithinAWeek: { valid: false } };
    }
  }
}

export interface UserAuthenticationTypeList {
  [key: string]: any;
  UserAuthenticationTypeModelList: Array<UserAuthenticationTypeModel>;
}

export interface UserAuthenticationTypeModel {
  authenticationTypeId: number;
  authenticationTypeName: string;
  userName: string;
  organizationMnemonic: string;
  sequence: number;
  isActive: boolean;
  isDefault: boolean;
  jsonData: string | null;
  userCheckEnrollCodeModel: UserCheckEnrollCodeModel | null
  pushEnabled?: boolean;
  revertAtTime: Date | null;
}

export interface UserCheckEnrollCodeModel {
  checkCode?: string;
  enrollUrl?: string;  
}

export enum PassCodeSourceType {
  Sms = 'Sms',
  Email = 'Email',
}

export enum PassCodeSource {
  PassCodeSMS = 'PassCodeSMS',
  PassCodeEmail = 'PassCodeEmail',
}

export type AuthenticationMethod = 'Password' | 'PassCode' | 'UserCode' | 'Push' | 'Hardware' | 'Yubikey' | 'FidoToken';

export const AuthenticationMethod = {
  Password: 'Password' as AuthenticationMethod,
  PassCode: 'PassCode' as AuthenticationMethod,
  UserCode: 'UserCode' as AuthenticationMethod,
  Push: 'Push' as AuthenticationMethod,
  Hardware: 'Hardware' as AuthenticationMethod,
  Yubikey: 'Yubikey' as AuthenticationMethod,
  FidoToken: 'FidoToken' as AuthenticationMethod
};

export interface AuthenticationMethodConfiguration { 
  id: number;
  organizationId: number;
  allowSecondFactor: boolean;
  enforceSecondFactor: boolean;
  passcode: AuthenticationMethodFlags;
  passcodeViaSms: boolean;
  passcodeViaEmail: boolean;
  softToken: AuthenticationMethodFlags;
  enforcePush: boolean;
  staticCode: AuthenticationMethodFlags;
  hardwareToken: AuthenticationMethodFlags;
  yubikey: AuthenticationMethodFlags;
  fidoToken: AuthenticationMethodFlags;
}

export enum AuthenticationMethodFlags {
    None = 0,
    Enabled = 1 << 0,
    UserSelectable = 1 << 1,
    AllowedAsTemp = 1 << 2
};
